import { type RefObject } from 'react';
import { Button } from 'react-bootstrap';
import { Trans, useTranslation } from 'react-i18next';
import UploadFileProgress from '../../FileNavigator/UploadFileProgress';
import spinnerTitle from '../../others/spinnerTitle';
import AiInfoBlock from '../../others/AiInfoBlock';

interface PaymentAiPanelProps {
    isBusy: boolean;
    handleOpenClick: () => void;
    processingLabel: string;
    phase: 'idle' | 'uploading' | 'processing';
    handleCancel: () => void;
    uploadProgress: number | boolean;
    refInputFile: RefObject<HTMLInputElement>;
    handleChangeFile: () => void;
}

const PaymentAiPanel = ({
    isBusy,
    handleOpenClick,
    processingLabel,
    phase,
    handleCancel,
    uploadProgress,
    refInputFile,
    handleChangeFile,
}: PaymentAiPanelProps) => {
    const { t } = useTranslation(['Warehouses']);

    return (
        <div className="pt-1">
            <AiInfoBlock title={t('paymentAi.infoTitle')}>
                <p>{t('paymentAi.infoText')}</p>
                <div className="ai-info-block-formats">
                    <span className="ai-info-block-formats-label">{t('paymentAi.formatsLabel')}</span>
                    {t('paymentAi.formatsList')}
                </div>
                <div className="d-flex flex-wrap gap-2 mt-3">
                    <Button type="button" variant="primary" size="sm" onClick={handleOpenClick} disabled={isBusy}>
                        {spinnerTitle(
                            <>
                                <i className="bi bi-stars me-1"></i>
                                {t('paymentAi.open')}
                            </>,
                            isBusy,
                            processingLabel,
                        )}
                    </Button>
                    {phase === 'processing' && (
                        <Button type="button" variant="outline-danger" size="sm" onClick={handleCancel}>
                            <i className="bi bi-stop-circle me-1"></i>
                            {t('paymentAi.cancel')}
                        </Button>
                    )}
                </div>
                <div className="small text-muted mt-2">
                    <Trans
                        i18nKey="paymentAi.editHint"
                        ns="Warehouses"
                        components={{ strong: <strong /> }}
                    />
                </div>
                {uploadProgress !== false && (
                    <div className="pt-2">
                        <UploadFileProgress progress={Number(uploadProgress)} />
                        <div className="small text-muted mt-2">{processingLabel}</div>
                    </div>
                )}
                <input ref={refInputFile} type="file" className="d-none" onChange={handleChangeFile} />
            </AiInfoBlock>
        </div>
    );
};

export default PaymentAiPanel;
